import { dayjs } from "neetocommons/utils";

export const REMOVE_SELECT_DOWN_ARROW = {
  DropdownIndicator: () => null,
  IndicatorSeparator: () => null,
};

export const BLUR_TEXT_WHEN_SELECT_MENU_IS_OPEN = {
  singleValue: (base, state) => ({
    ...base,
    color: state.selectProps.menuIsOpen ? "#c2c8cc" : base.color,
  }),
};

export const SLOT_TIME_FORMAT = "hh:mm A";
export const SLOT_TIME_FORMAT_24H = "HH:mm";

// eslint-disable-next-line @bigbinary/neeto/use-standard-date-time-formats
export const END_OF_DAY = dayjs().endOf("day").format(SLOT_TIME_FORMAT_24H);
